import { render, staticRenderFns } from "./ExcludedFinishesList.vue?vue&type=template&id=a13d915c"
import script from "./ExcludedFinishesList.vue?vue&type=script&lang=js"
export * from "./ExcludedFinishesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports